import { render } from "./SettingsAccount.vue?vue&type=template&id=763d02b0"
import script from "./SettingsAccount.vue?vue&type=script&lang=js"
export * from "./SettingsAccount.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__